export default __webpack_public_path__ + "static/meshery-clients-bc11d4e49ec98bedb3e45bbd79955951.webp";